import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './stores/auth';
import Login from './pages/Login';
import Home from './pages/Home';
import ConsultarPatente from './pages/ConsultarPatente';
import LabrarActa from './pages/LabrarActa';
import ConfirmarActa from './pages/ConfirmarActa';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.accessToken);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/consultar" element={<PrivateRoute><ConsultarPatente /></PrivateRoute>} />
      <Route path="/labrar" element={<PrivateRoute><LabrarActa /></PrivateRoute>} />
      <Route path="/confirmar" element={<PrivateRoute><ConfirmarActa /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
